<agr-dialog [data]="data" (alt)="alt()" (cancel)="cancel()" (confirm)="confirm()">
  <div class="dialog-content">
    <div class="top-content">
      @if ((data?.cartLineCount ?? 0) > 0) {
        <div class="notification notification-info">
          <mat-icon>information</mat-icon>
          <span class="text--black">
            {{ 'confirmOrder.existingOrderLinesInCartWarning' | translate }}
          </span>
        </div>
      }
      <ng-container>
        <div class="center-container">
          <form [formGroup]="form">
            <mat-form-field>
              <mat-label>{{ 'deliveryDate' | translate }}</mat-label>
              <input
                matInput
                formControlName="deliveryDate"
                [min]="today"
                [max]="lastDayOfNextYear"
                [matDatepicker]="picker"
                [matDatepickerFilter]="filterOutWeekends"
              />
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </form>
          <mat-list data-test="confirm-order-dialog-fertilizer">
            @for (orderLine of orderLines; track orderLine) {
              <mat-list-item data-test="confirm-order-fertilizer-order-line-row">
                <mat-icon matListItemIcon>store</mat-icon>
                <span matListItemTitle>
                  {{ getCropAid(orderLine.cropAidId)?.productName }}
                </span>
                <span matListItemLine>
                  {{ getPackageCount(orderLine.packageId) | agrNumber }} x
                  {{ getQuantityPerPackage(orderLine.packageId) }}
                  {{ getPackageUnitOfMeasurement(orderLine.packageId) }}
                </span>
              </mat-list-item>
            }
          </mat-list>
        </div>
      </ng-container>
    </div>

    @if (showAmountWarning()) {
      <div class="notification notification-warning">
        <mat-icon>warning</mat-icon>
        <span class="text--black"> {{ 'confirmOrder.amountWarning' | translate }}</span>
      </div>
    }
  </div>
</agr-dialog>
